const multimediaEndpoints = {
  base: '/v1/cms/multimedia',
  importUrl: '/v1/cms/multimedia/import-url',
  byId: (id) => `/v1/cms/multimedia/${id}`,
  download: (id) => `/v1/cms/multimedia/${encodeURIComponent(String(id || ''))}/download`,
  downloadAudio: '/v1/cms/multimedia/download-audio'
};

export default multimediaEndpoints;
